import { TSobReportSalesType } from 'legacy/lut/components/widgets/public/partner360/configs/reports'

import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

import { PREV_QUARTERS_MAPPER } from '../../configs/reports'

import { calculateSobAnalyticsForPeriod } from './sobAnalyticReport/weightedAverage/calculateSobAnalyticsForPeriod'

interface IParams {
  data: ISobAnalyticsReportJoined[]
  fYear: number
  quarters: number[]
  netNdp: TSobReportSalesType
}

export const calculateQoQ = ({ data, quarters, netNdp, fYear }: IParams) => {
  const currentYearData = data.filter((it) => it.FYear === fYear)
  const previousFYear = fYear - 1
  const previousYearData = data.filter((it) => it.FYear === previousFYear)

  const currYearCalcs = calculateSobAnalyticsForPeriod({
    data: currentYearData,
    quarters,
    netNdp,
  })

  const quarterKey = quarters.join(',')
  const minQuarter = Math.min(...quarters)
  const prevQuarters = PREV_QUARTERS_MAPPER[quarterKey]
  const shouldBePreviousYearQoQ = minQuarter === 1

  const prevYearCalcs = calculateSobAnalyticsForPeriod({
    data: shouldBePreviousYearQoQ ? previousYearData : currentYearData,
    quarters: prevQuarters,
    netNdp,
  })

  const currYearSob = currYearCalcs.sob || currYearCalcs.plainSob
  const prevYearSob = prevYearCalcs.sob || prevYearCalcs.plainSob

  if (!currYearSob || !prevYearSob) {
    return null
  }

  return currYearSob - prevYearSob
}
